import { render, staticRenderFns } from "./countdowns.vue?vue&type=template&id=53cd4252"
import script from "./countdowns.vue?vue&type=script&lang=js"
export * from "./countdowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports